import actions from '@/store/actions'
import getters from '@/store/getters'
import mutations from '@/store/mutations'
import { RootState } from '@/store/types'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state: RootState = {
  isLoadingApp: true,
  snackbar: {
    showing: false,
    type: '',
    message: '',
    timeout: 2000,
    clearable: false,
  },
  language: null,
  header: {
    content: {
      retailerLogo: '',
      referenceNumber: '',
      createdAt: '',
      timezone: '',
      carrierLogo: '',
      carrierName: '',
      lockerLogo: '',
      lockerName: '',
      deliveryDate: '',
      pickingDate: '',
    },
    config: {
      showLogo: false,
      showOrderId: false,
      showLockerLogo: false,
      showOrderCreationDate: false,
      showDeliveryDate: false,
      showCarrierName: false,
      showPickingDate: false,
    },
  },
}

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
})
